/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type IInsurancePolicyFragment = { __typename?: 'HighwayInsurancePolicy' } & Pick<
  Types.IHighwayInsurancePolicy,
  | 'id'
  | 'anyAuto'
  | 'cancellationDate'
  | 'coverageLimit'
  | 'createdAt'
  | 'deletedAt'
  | 'effectiveDate'
  | 'expirationDate'
  | 'hiredAutos'
  | 'isRefrigerationBreakdownIncluded'
  | 'isType'
  | 'policyNumber'
  | 'scheduledAutos'
  | 'status'
  | 'statutoryLimits'
  | 'updatedAt'
> & {
    insurer?: Types.Maybe<
      { __typename?: 'HighwayInsurer' } & Pick<Types.IHighwayInsurer, 'id' | 'name'>
    >
    insuranceCertificate?: Types.Maybe<
      { __typename?: 'HighwayInsuranceCertificate' } & Pick<
        Types.IHighwayInsuranceCertificate,
        'id' | 'url' | 'signedUrl'
      >
    >
    transfixFlags?: Types.Maybe<
      { __typename?: 'TransfixHighwayInsurancePolicyFlag' } & Pick<
        Types.ITransfixHighwayInsurancePolicyFlag,
        | 'id'
        | 'transfixAdditionalInsured'
        | 'transfixAdditionalInsuredUpdatedBy'
        | 'transfixAdditionalInsuredUpdatedAt'
        | 'transfixHolder'
        | 'transfixHolderUpdatedBy'
        | 'transfixHolderUpdatedAt'
        | 'transfixLossPayee'
        | 'transfixLossPayeeUpdatedBy'
        | 'transfixLossPayeeUpdatedAt'
      >
    >
  }

export const InsurancePolicyFragmentDoc = gql`
  fragment InsurancePolicy on HighwayInsurancePolicy {
    id
    anyAuto
    cancellationDate
    coverageLimit
    createdAt
    deletedAt
    effectiveDate
    expirationDate
    hiredAutos
    insurer {
      id
      name
    }
    isRefrigerationBreakdownIncluded
    isType
    insuranceCertificate {
      id
      url
      signedUrl
    }
    policyNumber
    scheduledAutos
    status
    statutoryLimits
    updatedAt
    transfixFlags {
      id
      transfixAdditionalInsured
      transfixAdditionalInsuredUpdatedBy
      transfixAdditionalInsuredUpdatedAt
      transfixHolder
      transfixHolderUpdatedBy
      transfixHolderUpdatedAt
      transfixLossPayee
      transfixLossPayeeUpdatedBy
      transfixLossPayeeUpdatedAt
    }
  }
`
